import { call } from "redux-saga/effects";
import dashboardActions from "../../constants/dashboardActions";
import constants from "../../constants/constants";
import { getDataFromAPI } from "../../utils/sagas";
import { getToken } from "../../utils/worker";
import urls from "../../api/urls";

const getTokenId = getToken() || null;
const authToken = getTokenId || null;

export function* getDashboardOverviewWorker({ data }) {
  const { premiseId, tab } = data || {};
  let urlStr = `${urls.DASHBOARD_OVERVIEW_SHIPMENT}?premiseId=${premiseId}`;
  if (tab) {
    urlStr += `&tab=${tab}`;
  }
  const reqParams = {
    url: urlStr,
    successAction: dashboardActions.GET_DASHBOARD_OVERVIEW_SUCCESS,
    errorAction: dashboardActions.GET_DASHBOARD_OVERVIEW_ERROR,
    params: { authToken },
  };

  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET);
}

export function* getDashboardIncomingOverviewWorker({ data }) {
  const { topremiseid, tab } = data || {};
  let urlStr = `${urls.DASHBOARD_INCOMING_OVERVIEW_SHIPMENT}?topremiseid=${topremiseid}`;
  if (tab) {
    urlStr += `&tab=${tab}`;
  }
  const reqParams = {
    url: urlStr,
    successAction: dashboardActions.GET_DASHBOARD_INCOMING_OVERVIEW_SUCCESS,
    errorAction: dashboardActions.GET_DASHBOARD_INCOMING_OVERVIEW_ERROR,
    params: { authToken },
  };

  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET);
}

export function* getDashboardOverviewBagWorker({ data }) {
  const { premiseId, tab } = data || {};
  let urlStr = `${urls.DASHBOARD_OVERVIEW_BAG}?premiseId=${premiseId}`;
  if (tab) {
    urlStr += `&tab=${tab}`;
  }
  const reqParams = {
    url: urlStr,
    successAction: dashboardActions.GET_DASHBOARD_OVERVIEW_BAG_SUCCESS,
    errorAction: dashboardActions.GET_DASHBOARD_OVERVIEW_BAG_ERROR,
    params: { authToken },
  };

  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET);
}

export function* getDashboardIncomingOverviewBagWorker({ data }) {
  const { topremiseid, tab } = data || {};
  let urlStr = `${urls.DASHBOARD_INCOMING_OVERVIEW_BAG}?topremiseid=${topremiseid}`;
  if (tab) {
    urlStr += `&tab=${tab}`;
  }
  const reqParams = {
    url: urlStr,
    successAction: dashboardActions.GET_DASHBOARD_INCOMING_OVERVIEW_BAG_SUCCESS,
    errorAction: dashboardActions.GET_DASHBOARD_INCOMING_OVERVIEW_BAG_ERROR,
    params: { authToken },
  };

  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET);
}

export function* getDashboardIncomingBagsClickableWorker({ data }) {
  const { topremiseid, tab, page, size } = data || {};
  let urlStr = `${urls.DASHBOARD_INCOMING_BAGS_CLICKABLE}?topremiseid=${topremiseid}&page=${page}&size=${size}`;
  if (tab) {
    urlStr += `&tab=${tab}`;
  }
  const reqParams = {
    url: urlStr,
    successAction: dashboardActions.GET_DASHBOARD_INCOMING_BAGS_CLICKABLE_SUCCESS,
    errorAction: dashboardActions.GET_DASHBOARD_INCOMING_BAGS_CLICKABLE_ERROR,
    params: { authToken },
  };

  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET);
}

export function* getDashboardOutscanBagsClickableWorker({ data }) {
  const { premiseid, tab, page, size } = data || {};
  let urlStr = `${urls.DASHBOARD_OUTSCAN_BAGS_CLICKABLE}?premiseid=${premiseid}&page=${page}&size=${size}`;
  if (tab) {
    urlStr += `&tab=${tab}`;
  }
  const reqParams = {
    url: urlStr,
    successAction: dashboardActions.GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE_SUCCESS,
    errorAction: dashboardActions.GET_DASHBOARD_OUTSCAN_BAGS_CLICKABLE_ERROR,
    params: { authToken },
  };

  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET);
}

export function* getDashboardOutscanToCpShipmentsClickableWorker({ data }) {
  const { premiseid, tab, page, size } = data || {};
  let urlStr = `${urls.DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE}?premiseid=${premiseid}&page=${page}&size=${size}`;
  if (tab) {
    urlStr += `&tab=${tab}`;
  }
  const reqParams = {
    url: urlStr,
    successAction: dashboardActions.GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE_SUCCESS,
    errorAction: dashboardActions.GET_DASHBOARD_OUTSCAN_TO_CP_SHIPMENTS_CLICKABLE_ERROR,
    params: { authToken },
  };

  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET);
}

export function* getDashboardOutscanToCpBagsClickableWorker({ data }) {
  const { premiseid, tab, page, size } = data || {};
  let urlStr = `${urls.DASHBOARD_OUTSCAN_TO_CP_BAGS_CLICKABLE}?premiseid=${premiseid}&page=${page}&size=${size}`;
  if (tab) {
    urlStr += `&tab=${tab}`;
  }
  const reqParams = {
    url: urlStr,
    successAction: dashboardActions.GET_DASHBOARD_OUTSCAN_TO_CP_BAGS_CLICKABLE_SUCCESS,
    errorAction: dashboardActions.GET_DASHBOARD_OUTSCAN_TO_CP_BAGS_CLICKABLE_ERROR,
    params: { authToken },
  };

  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET);
}

export function* getDashboardInscanShipmentsClickableWorker({ data }) {
  const { premiseid, tab, page, size } = data || {};
  let urlStr = `${urls.DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE}?premiseid=${premiseid}&page=${page}&size=${size}`;
  if (tab) {
    urlStr += `&tab=${tab}`;
  }
  const reqParams = {
    url: urlStr,
    successAction: dashboardActions.GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE_SUCCESS,
    errorAction: dashboardActions.GET_DASHBOARD_INSCAN_SHIPMENTS_CLICKABLE_ERROR,
    params: { authToken },
  };

  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET);
}

export function* getDashboardOutscanShipmentsClickableWorker({ data }) {
  const { premiseid, tab, page, size } = data || {};
  let urlStr = `${urls.DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE}?premiseid=${premiseid}&page=${page}&size=${size}`;
  if (tab) {
    urlStr += `&tab=${tab}`;
  }
  const reqParams = {
    url: urlStr,
    successAction: dashboardActions.GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE_SUCCESS,
    errorAction: dashboardActions.GET_DASHBOARD_OUTSCAN_SHIPMENTS_CLICKABLE_ERROR,
    params: { authToken },
  };

  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET);
}

export function* getDashboardIncomingShipmentsClickableWorker({ data }) {
  const { incominghubid, tab, page, size } = data || {};
  let urlStr = `${urls.DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE}?incominghubid=${incominghubid}&page=${page}&size=${size}`;
  if (tab) {
    urlStr += `&tab=${tab}`;
  }
  const reqParams = {
    url: urlStr,
    successAction: dashboardActions.GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE_SUCCESS,
    errorAction: dashboardActions.GET_DASHBOARD_INCOMING_SHIPMENTS_CLICKABLE_ERROR,
    params: { authToken },
  };

  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET);
}

export function* dashboardInscanBagsClickableWorker({ data }) {
  const { premiseid, tab, page, size } = data || {};
  let urlStr = `${urls.DASHBOARD_INSCAN_BAGS_CLICKABLE}?premiseid=${premiseid}&page=${page}&size=${size}`;
  if (tab) {
    urlStr += `&tab=${tab}`;
  }
  const reqParams = {
    url: urlStr,
    successAction: dashboardActions.GET_DASHBOARD_INSCAN_BAGS_CLICKABLE_SUCCESS,
    errorAction: dashboardActions.GET_DASHBOARD_INSCAN_BAGS_CLICKABLE_ERROR,
    params: { authToken },
  };

  yield call(getDataFromAPI, reqParams, constants.HTTP_METHODS.GET);
}
